export interface IAutoFillCompanyDetectionDelegation {
    detectAutofill(companyId: string, legalFormId: string, accountingBasisId?: string, locale?: string): void;
}
